var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "live-play-stream-sl",
  "use": "live-play-stream-sl-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"live-play-stream-sl\">\n  <path d=\"M0 .5v14.997a.5.5 0 0 0 .75.433l13-7.483a.5.5 0 0 0 0-.866L.75.067A.5.5 0 0 0 0 .5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id